import React from 'react'
import HeaderResume from '../../components/HeaderResume.jsx'
import ResumeBody from '../../components/ResumeBody'
function Curriculo() {
    return (
        <>
            <span id='Início' />
            <HeaderResume title1='Formação' title2="Experiência" title3='Cursos' title4='Conhecimentos' />
            <ResumeBody />


        </>

    )
}

export default Curriculo
